module.exports = __webpack_public_path__ + "img/unlink.810f1059.png";